import { FC, Fragment, useReducer } from 'react';

import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { PartnerForm, initialValues } from '../partnerFormDialog/form';
import { PartnerFormDialog } from '../partnerFormDialog/PartnerFormDialog';

import { partnersService } from 'v2/api/partnersService';
import { handleHttpError } from 'v2/utils';

interface CreatePartnerButtonProps {
  onSuccess: VoidFunction;
}

export const CreatePartnerButton: FC<CreatePartnerButtonProps> = ({ onSuccess }) => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger, isMutating } = useSWRMutation('createPartner', partnersService.createPartner, {
    onSuccess: () => {
      onSuccess();
      toast.success('New partner has been successfully created');
      setOpen();
    },
    onError: handleHttpError,
  });

  const handleSubmit = (values: PartnerForm, resetForm: VoidFunction) => {
    trigger(values).then(() => resetForm());
  };

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<Plus />} variant="contained" size="large">
        Create Partner
      </Button>

      <PartnerFormDialog
        title="Create Partner"
        isOpen={isOpen}
        onClose={setOpen}
        initialValues={initialValues}
        isSubmitting={isMutating}
        onSubmit={handleSubmit}
      />
    </Fragment>
  );
};
